import * as pdfjs from "pdfjs-dist";
export const extractTextFromPDF = async (file: File): Promise<string> => {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onload = async () => {
      try {
        const typedArray = new Uint8Array(reader.result as ArrayBuffer);
        const pdf = await pdfjs.getDocument({ data: typedArray }).promise;
        let text = "";

        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i);
          const content = await page.getTextContent();
          text += content.items
            .map((item: any) =>
              item && typeof item === "object" && "str" in item ? item.str : ""
            )
            .join(" ");
        }

        resolve(text);
      } catch (error) {
        console.error("Error processing PDF:", error);
        reject(error);
      }
    };

    reader.onerror = (error) => {
      console.error("FileReader error:", error);
      reject(error);
    };
    reader.readAsArrayBuffer(file);
  });
};
